import * as React from "react";
import { Trad } from "../components";

interface IValidationText {
    Type: "Text";
    MinimumLength: number;
}

interface IValidationEmail {
    Type: "Email";
}

interface IValidationPassword {
    Type: "Password";
}

interface IValidationVatNumber {
    Type: "VatNumber";
}


interface IValidationVatObbligatorio {
    Type: "VatObbligatorio";
}

interface IValidationFiscalCode {
    Type: "FiscalCode";
}

export type ValidationType = IValidationText | IValidationEmail | IValidationPassword | IValidationVatNumber | IValidationFiscalCode | IValidationVatObbligatorio;

export interface IValidationForm {
    Fields: { [Field: string]: boolean };
    Messages: { [Field: string]: string };
}

export function useValidationForm(): [(tipo: ValidationType, field: string, value: any) => void, boolean, (field: string) => boolean, (field: string) => string, (field: string) => void] {
    let [Form, setValidate] = React.useState<IValidationForm>({ Fields: {}, Messages: {} });

    const setValidateField = (tipo: ValidationType, field: string, value: string, message: string = "") => {
        const updatedForm = { ...Form };
        updatedForm.Fields[field] = false;
        updatedForm.Messages[field] = "";

        switch (tipo.Type) {
            case "Email":
                let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
                if (!value || value.length <= 5 || !EMAIL_REGEXP.test(value)) {
                    updatedForm.Fields[field] = true;
                    updatedForm.Messages[field] = message.length > 0 ? message : Trad.Trad("Value is not valid");
                }
                break;
            case "Text":
                if ((value || "").length < tipo.MinimumLength) {
                    updatedForm.Fields[field] = true;
                    updatedForm.Messages[field] = message.length > 0 ? message : "Minimum length is " + tipo.MinimumLength.toString();
                }
                break;
            case "Password":
                value = value || "";
                if (value.length >= 1 && value.length < 8) {
                    updatedForm.Fields[field] = true;
                    updatedForm.Messages[field] = message.length > 0 ? message : "Minimum length is 8";
                }
                if (value.length >= 8) {
                    let NumbersCount = 0;
                    let LowCaseCount = 0;
                    let UpCaseCount = 0;
                    for (let c = 0; c < value.length; c++) {
                        if (value[c] >= "0" && value[c] <= "9") NumbersCount++;
                        if (value[c] >= "a" && value[c] <= "z") LowCaseCount++;
                        if (value[c] >= "A" && value[c] <= "Z") UpCaseCount++;
                    }
                    if (NumbersCount === 0 || LowCaseCount === 0 || UpCaseCount === 0) {
                        updatedForm.Fields[field] = true;
                        updatedForm.Messages[field] = message.length > 0 ? message : "Password too easy";
                    }
                }
                break;
            case "VatNumber":
                const VAT_REGEXP = /^(IT){0,1}[0-9]{11}$/;
                if (!value || !VAT_REGEXP.test(value)) {
                    updatedForm.Fields[field] = true;
                    updatedForm.Messages[field] = message.length > 0 ? message : Trad.Trad("La Partita iva non è valida");
                }
                break;
            case "FiscalCode":
                const FISCAL_CODE_REGEXP = /^(?:(?:[B-DF-HJ-NP-TV-Z]|[AEIOU])[AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[1256LMRS][\dLMNP-V])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/;
                if (!value || !FISCAL_CODE_REGEXP.test(value)) {
                    updatedForm.Fields[field] = true;
                    updatedForm.Messages[field] = message.length > 0 ? message : Trad.Trad("Value is not valid");
                }
                break;
            case "VatObbligatorio":
                if (!value) {
                    updatedForm.Fields[field] = true;
                    updatedForm.Messages[field] = message.length > 0 ? message : Trad.Trad("Campo Obbligatorio");
                }
        }

        setValidate(updatedForm);
    };

    const Validate = (): boolean => {
        for (let Field in Form.Fields) {
            let Value = Form.Fields[Field];
            if (Value) {
                return false;
            }
        }
        return true;
    };

    const getFieldValidation = (field: string): boolean => {
        let Message = Form.Fields[field];
        return Message || false;
    };

    const getFieldValidationMessage = (field: string): string => {
        let Message = Form.Messages[field];
        return Message || "";
    };

    const deleteFieldValidation = (field: string) => {
        const updatedForm = { ...Form };

        delete updatedForm.Fields[field];
        delete updatedForm.Messages[field];
        setValidate(updatedForm);
    };

    const useValidationEmail = (field: string, value: any) => {
        return setValidateField({ Type: "Email" }, field, value);
    };
    const useValidationLength = (field: string, value: any, minLength: number) => {
        return setValidateField({ Type: "Text", MinimumLength: minLength }, field, value);
    };
    const useValidationPassword = (field: string, value: any) => {
        return setValidateField({ Type: "Password" }, field, value);
    };
    const VatNumber = (field: string, value: any) => {
        return setValidateField({ Type: "VatNumber" }, field, value);
    };
    const useValidationFiscalCode = (field: string, value: any) => {
        return setValidateField({ Type: "FiscalCode" }, field, value);
    };
    const VatObbligatorio = (field: string, value: any) => {
        return setValidateField({ Type: "VatObbligatorio" }, field, value);
    };

    return [setValidateField, Validate(), getFieldValidation, getFieldValidationMessage, deleteFieldValidation];
}



// WEBPACK FOOTER //
// ./src/hooks/Validation.ts